export default "__VITE_ASSET__DHnjFq23__"